import { useTheme } from "@mui/material";
import { useMemo } from "react";
import { Assessment as AssessmentIcon, CheckCircle as CheckCircleIcon, Schedule as ScheduleIcon, Flag as FlagIcon } from "@mui/icons-material";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { AuditStatus } from "../../../../../utils/enums";

const AuditSummary = ({ audits = [], loading = false }) => {
  const theme = useTheme();

  const stats = useMemo(() => {
    if (loading) return { total: 0, archived: 0, completed: 0 };

    const total = audits.length;
    const completed = audits.filter(
      (a) => a.audit_status && a.audit_status === AuditStatus.COMPLETED
    ).length;

    const archived = audits.filter(
      (a) => a.audit_status === AuditStatus.ARCHIVED
    ).length;

    return { total, archived, completed };
  }, [audits, loading]);

  const displayStat = (value) => {
    if (loading) return "-";
    return value;
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Paper elevation={0} sx={{
          p: 2,
          borderRadius: "12px",
          border: "1px solid #E8EAED",
          backgroundColor: "#FFFFFF",
          flex: 1,
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            transform: "translateY(-2px)",
          },
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" sx={{ fontSize: "20px" }}>
                {displayStat(stats.total)}
              </Typography>
              <Typography variant="body2">
                Total Audits
              </Typography>
            </Box>
            <AssessmentIcon sx={{ color: theme.customColors.icons.primary, fontSize: 24 }} />
          </Box>
        </Paper>

        <Paper elevation={0} sx={{
          p: 2,
          borderRadius: "12px",
          border: "1px solid #E8EAED",
          backgroundColor: "#FFFFFF",
          flex: 1,
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            transform: "translateY(-2px)",
          },
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" sx={{ fontSize: "20px", color: "#10b981" }}>
                {displayStat(stats.archived)}
              </Typography>
              <Typography variant="body2">
                Archived Audits
              </Typography>
            </Box>
            <Box sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "#10b981",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <ScheduleIcon sx={{ color: "#FFFFFF", fontSize: 16 }} />
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={{
          p: 2,
          borderRadius: "12px",
          border: "1px solid #E8EAED",
          backgroundColor: "#FFFFFF",
          flex: 1,
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            transform: "translateY(-2px)",
          },
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" sx={{ fontSize: "20px", color: "#6b7280" }}>
                {displayStat(stats.completed)}
              </Typography>
              <Typography variant="body2">
                Completed
              </Typography>
            </Box>
            <Box sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "#6b7280",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <CheckCircleIcon sx={{ color: "#FFFFFF", fontSize: 16 }} />
            </Box>
          </Box>
        </Paper>
      </Stack>
    </Box>
  );
};

export default AuditSummary;
